<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss"></style>

<script>
import Vue from "vue";
import VueFbCustomerChat from "vue-fb-customer-chat";
import VueAnalytics from "vue-analytics";

Vue.use(VueFbCustomerChat, {
  page_id: 105400935001163, //  change 'null' to your Facebook Page ID,
  theme_color: "#333333", // theme color in HEX
  locale: "en_US", // default 'en_US'
});

Vue.use(VueAnalytics, {
  id: "UA-19553488-43",
});

export default {
  data() {
    return {
      isCondensed: false,
    };
  },
};
</script>
